import { Box, Typography } from "@mui/material";

export const SliceTooltip = ({ slice, colors }) => {
  const validPoints = slice.points.filter(
    (point) => point.data.y !== null && point.data.y !== undefined
  );

  if (validPoints.length === 0) return null;

  return (
    <Box
      style={{
        background: "white",
        width: "180px",
        padding: "9px 12px",
        border: "1px solid #ccc",
        borderRadius: "8px",
        display: "flex",
        flexDirection: "column",
        gap: "4px",
      }}
    >
      {validPoints.map((point) => (
        <Box
          key={point.id}
          sx={{
            display: "flex",
            flexDirection: "row",
            gap: 1,
            alignItems: "center",
          }}
        >
          <Box
            sx={{
              backgroundColor: point.seriesColor,
              width: "10px",
              height: "10px",
              borderRadius: "2px",
            }}
          />
          <Typography variant="overline" color={colors.text_primary}>
            {point.seriesId}:
          </Typography>
          <Typography
            variant="caption"
            color={colors.text_primary}
            sx={{ padding: "3px 0" }}
          >
            {point.data.yFormatted}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};
